import { css } from '@emotion/react'

export const radioGroupMainClass = () => css`
  align-items: flex-start;
`
